import { useEffect, useState } from "react";
import { adminApi } from "../../lib/api";

export default function AdminDashboard() {
  const [m, setM] = useState(null);
  useEffect(() => { adminApi.get("/metrics").then(setM).catch(() => {}); }, []);
  if (!m) return <p className="text-zinc-500" data-testid="metrics-loading">Loading metrics...</p>;
  const cards = [
    { label: "Total Magazines", value: m.total_magazines },
    { label: "Publishers", value: m.total_publishers },
    { label: "Active Subscriptions", value: m.active_subscriptions },
    { label: "Revenue This Month", value: `₹${(m.revenue_this_month || 0).toLocaleString("en-IN")}` },
  ];
  return (
    <div data-testid="admin-dashboard">
      <h1 className="text-xl font-bold text-zinc-900 mb-6">Dashboard</h1>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        {cards.map((c) => (
          <div key={c.label} className="bg-white border border-zinc-200 rounded-md p-4" data-testid={`metric-${c.label.toLowerCase().replace(/\s/g, "-")}`}>
            <div className="text-xs text-zinc-500">{c.label}</div>
            <div className="text-2xl font-bold text-zinc-900 mt-1">{c.value}</div>
          </div>
        ))}
      </div>
      <h2 className="text-sm font-semibold text-zinc-900 mb-3">Recent Orders</h2>
      <div className="bg-white border border-zinc-200 rounded-md overflow-x-auto">
        <table className="w-full text-sm" data-testid="recent-orders-table">
          <thead>
            <tr className="text-left text-xs text-zinc-500 border-b border-zinc-200">
              <th className="px-4 py-3">Order</th><th className="px-4 py-3">Subscriber</th><th className="px-4 py-3">Plan</th>
              <th className="px-4 py-3">Amount</th><th className="px-4 py-3">Status</th>
            </tr>
          </thead>
          <tbody>
            {m.recent_orders.map((o) => (
              <tr key={o.id} className="border-b border-zinc-100 last:border-0">
                <td className="px-4 py-3 font-mono text-xs">{o.order_number}</td>
                <td className="px-4 py-3">{o.subscriber?.name}</td>
                <td className="px-4 py-3">{o.plan_name}</td>
                <td className="px-4 py-3">₹{(o.amount || 0).toLocaleString("en-IN")}</td>
                <td className="px-4 py-3">
                  <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${o.status === "paid" ? "bg-green-100 text-green-700" : o.status === "pending" ? "bg-amber-100 text-amber-700" : o.status === "failed" ? "bg-red-100 text-red-700" : o.status === "refunded" ? "bg-blue-100 text-blue-700" : "bg-zinc-100 text-zinc-600"}`}>{o.status}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
